import { Clip } from '../components/video_player/VideoPlayer'

export async function fetchSensorData(
  sensorType: 'accelerometer' | 'emg' | 'bioz' | 'temperature' | 'ppg' | 'spo2',
  currentClip: Clip,
): Promise<{ x: number; y: number }[]> {
  try {
    const requestOptions = {
      method: 'GET',
      credentials: 'include' as 'include' | 'same-origin' | 'omit',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }

    let apiUrl: string

    // Set API endpoint based on the sensor type
    if (sensorType === 'accelerometer') {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/data/accelerometer/${currentClip.videoName}/${currentClip.startTime}/${currentClip.endTime}`
    } else if (sensorType === 'emg') {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/data/emg/${currentClip.videoName}/${currentClip.startTime}/${currentClip.endTime}`
    } else if (sensorType === 'bioz') {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/data/bioz/${currentClip.videoName}/${currentClip.startTime}/${currentClip.endTime}`
    } else if (sensorType === 'temperature') {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/data/temperature/${currentClip.videoName}/${currentClip.startTime}/${currentClip.endTime}`
    } else if (sensorType === 'ppg') {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/data/ppg/${currentClip.videoName}/${currentClip.startTime}/${currentClip.endTime}`
    } else if (sensorType === 'spo2') {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/data/spo2/${currentClip.videoName}/${currentClip.startTime}/${currentClip.endTime}`
    } else {
      throw new Error('Invalid sensor type')
    }

    const response = await fetch(apiUrl, requestOptions)

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    return data.data
  } catch (error) {
    console.error(`Error fetching ${sensorType} data from backend:`, error)
    return []
  }
}

export function generateInitialData(): { x: number; y: number }[] {
  const data = []
  let prev = -1000

  for (let i = 0; i < 1000; i += 1) {
    prev += 5 - Math.random() * 10
    data.push({ x: i, y: prev })
  }

  return data
}
